import AddIcon from '@mui/icons-material/Add';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { Button, CircularProgress, Divider, FormControl, InputAdornment, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { ModalAlert } from '../../components/modal';
import BasicTable from '../../components/table';
import { TableBar } from '../../components/table/styles';
import { api } from '../../services/axios';
import { AddModal } from './styles';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import Modal from "react-modal";
import { ModalAlertDiv } from '../../components/modal/style';
import { DateRange, Calendar } from 'react-date-range';
import moment from 'moment/moment';
import { DatePicker } from '@mui/x-date-pickers';

const defaultForm = {
  company: '',
  adress: '',
  city: '',
  country: '',
  language: 'es'
}

const defaultError = {
  company: false,
  adress: false,
  city: false,
  country: false,
  language: false,
}

const Dam = () => {
  const url = "core/ajax/dam"
  const headers = [
    { label: 'Id', value: 'IdCity' },
    { label: 'UF', value: 'UF' },
    { label: 'City', value: 'City' },
    { label: 'Date to Launch', value: 'Date_launch' },
    { label: 'Total', value: 'TOTAL' },
    { label: 'Processed', value: 'SUCESSO' },
    { label: 'Not Processed', value: 'NAOPROCESSADO' },
    { label: 'Duplicated', value: 'DUPLICADO' },
    { label: 'Error Lead', value: 'LEADINCONCISTENTE' },
    { label: 'Create Date', value: 'create_at' },
    { label: 'Actions', value: 'Actions' },
  ]

  const [showModal, setShowModal] = useState(false)
  const [rows, setRows] = useState({ default: [], filter: [] })
  const [error, setError] = useState(defaultError)
  const [form, setForm] = useState(defaultForm);

  const [date, setDate] = useState(moment());


  const [alert, setAlert] = useState({ msg: '', status: '' });
  const [showAlert, setShowAlert] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showDam, setShowDam] = useState(false);
  const [id, setId] = useState();
  const [isCreate, setIsCreate] = useState(true);


  useEffect(() => {
    listUpdate()
  }, [])

  const listUpdate = () => {
    api.post(url, {
      type: 'list',
      authx: ''
    })
      .then(function (res) {
        setRows({ default: res.data, filter: res.data })
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const validation = () => {
    // setError({
    //   company: form.company === '' ? true : false,
    //   adress: form.adress === '' ? true : false,
    //   city: form.city === '' ? true : false,
    //   country: form.country === '' ? true : false,
    //   language: form.language === '' ? true : false,
    // })

    if (form.UF === '' || form.City === ''
      || form.Date_launch === '') {
      return false
    } else {
      return true
    }
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      // height: "90%",
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',

    }
  };

  const updateForm = (row) => {
    setForm({
      UF: row.UF,
      City: row.City,
    })
    setIsCreate(false)
    setShowModal(true)
    setId(row.IdCity)
    setDate(moment(row.Date_launch))
  }

  const confirmUpdateForm = () => {
    api.post(url, {
      type: 'update',
      UF: form.UF,
      City: form.City,
      Date_launch: date.format('YYYY-MM-DD'),
      IdCity: id,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const createDam = () => {
    api.post(url, {
      type: 'insert',
      UF: form.UF,
      City: form.City,
      Date_launch: date.format('YYYY-MM-DD'),
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const onDelete = (id) => {
    setId(id)
    setShowDelete(!showDelete)
  }

  const confirmDelete = () => {
    api.post(url, {
      type: 'delete',
      IdCity: id,
      authx: ''
    })
      .then(function (res) {
        setAlert(res.data)
        listUpdate()
      })
      .catch(function (error) {
        setAlert({ msg: 'Ocorreu um erro', status: 'error' })
        console.log(error);
      });
  }

  const releaseDam = (id) => {
    setId(id)
    setShowDam(!showDam)
  }

  const confirmRelease = () => {
    const url = 'core/engine/damEngine.php'

    id === null ?
      api.post(url)
        .then(function (res) {
          setAlert({ ...alert, msg: res.data })
          listUpdate()
        })
        .catch(function (error) {
          setAlert({ msg: 'Ocorreu um erro', status: 'error' })
          console.log(error);
        }) :

      api.post(url, {
        idCidade: id,
        authx: id ? '' : null
      })
        .then(function (res) {
          setAlert({ ...alert, msg: res.data })
          listUpdate()
        })
        .catch(function (error) {
          setAlert({ msg: 'Ocorreu um erro', status: 'error' })
          console.log(error);
        })
    setId(null)
  }

  const inputFilter = (e) => {
    const filter = rows.default.filter((row) => {
      return row.City.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.IdCity.includes(e.target.value) ||
        row.UF.toLowerCase().includes(e.target.value.toLowerCase())
    });
    setRows({ ...rows, filter })
    console.log(filter);
  }


  return (
    <TableBar>
      <h1>List Dammed cities</h1>
      <div className='buttons'>
        <TextField
          label="Search"
          variant="outlined"
          size='small'
          onChange={inputFilter}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SearchOutlinedIcon />
              </InputAdornment>
            ),
          }}
        />

        <Stack direction="row" spacing={2}>
          <Button startIcon={<AddIcon />} onClick={() => {
            setShowModal(!showModal)
            setIsCreate(true)
          }} variant="contained">Add</Button>

          <Button onClick={() => {
            releaseDam()
          }} variant="contained">Process</Button>
        </Stack>
      </div>

      <BasicTable type={'dam'} headers={headers} rowsProps={rows.filter} updateForm={updateForm} onDelete={onDelete} releaseDam={releaseDam} />

      <Modal isOpen={showModal}
        onRequestClose={() => {
          setShowModal(false)
          setForm(defaultForm)
          setError(defaultError)
        }}
        style={customStyles}
        ariaHideApp={false}>
        <AddModal>
          <h1>City</h1>

          <Divider className='divider' variant="middle" />

          <Stack spacing={2}>
            <TextField label="UF" variant="outlined"
              helperText={error.UF ? "Incorrect entry." : ""}
              error={error.UF}
              value={form.UF}
              onChange={(e) => {
                e.target.value !== '' ? setError({ ...error, UF: false }) : setError({ ...error, UF: true })
                setForm({
                  ...form,
                  UF: e.target.value
                })
              }} />

            <TextField label="City" variant="outlined"
              helperText={error.City ? "Incorrect entry." : ""}
              error={error.City}
              value={form.City}
              onChange={(e) => {
                e.target.value !== '' ? setError({ ...error, City: false }) : setError({ ...error, City: true })
                setForm({
                  ...form,
                  City: e.target.value
                })
              }} />

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label="Date"
                format='YYYY-MM-DD'
                value={date}
                onChange={(value) => setDate((value))}
              />
            </LocalizationProvider>
            <Button onClick={() => {
              if (validation()) {
                isCreate ? createDam() : confirmUpdateForm()
                setShowAlert(!showAlert)
              } else {
                console.log(form);
              }
            }} variant="contained">{isCreate ? 'Create' : 'Update'}</Button>

          </Stack>
        </AddModal>
      </Modal>

      {/* Modal de Alerta */}
      <ModalAlert showModal={showAlert} onClose={() => {
        setShowAlert(!showAlert)
        setAlert({ msg: '', status: undefined })
      }} onClickOutside={false}>
        {alert.status === undefined ?
          <ModalAlertDiv>
            <CircularProgress />
            <h1>Creating generator...</h1>
            <p>Please, wait...</p>
          </ModalAlertDiv>
          : alert.status === 'ok' ?
            <ModalAlertDiv>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>

              <Button onClick={() => {
                setShowAlert(false)
              }} variant="contained">Ok</Button>
            </ModalAlertDiv>
            :
            <ModalAlertDiv>
              <h1>{alert.msg}</h1>
              <h3>:&#40;	</h3>
              <h3>{alert.msg}</h3>

            </ModalAlertDiv>}
      </ModalAlert>

      {/* Modal de delete */}
      <ModalAlert showModal={showDelete} onClose={() => {
        setShowDelete(!showDelete)
        setAlert({ msg: '', status: undefined })
      }}>

        <ModalAlertDiv>

          {alert.code === 200 ?
            <>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <h1>Success!</h1>
              <p>Provider successfully deleted</p>
              <div>
                <Button onClick={() => {
                  setShowDelete(false)
                  setAlert({})
                }} variant="contained">Ok</Button>
              </div>
            </>
            :
            alert.code === 400 ?
              <>
                <h1>Error!</h1>
                <p>{alert.msg}</p>
                <Button onClick={() => {
                  setShowDelete(false)
                  setAlert({})
                }} variant="contained" color='warning'>Ok</Button>
              </>
              :
              <>
                <h1>Are you sure?</h1>
                <p>Are you sure that you want to delete this generator?</p>
                <div>
                  <Button sx={{ marginRight: '1rem' }} onClick={() => {
                    setShowDelete(false)
                    setAlert({})
                  }} variant="contained" color='error'>Cancel</Button>

                  <Button onClick={() => {
                    confirmDelete()
                    setAlert({})
                  }} variant="contained">Yes</Button>
                </div>
              </>}


        </ModalAlertDiv>
      </ModalAlert>

      {/* Modal de Dam */}
      <ModalAlert showModal={showDam}
        maxHeight={'80%'}
        onClose={() => {
          setShowDam(!showDam)
          setAlert({ msg: '' })
        }}
      >

        <ModalAlertDiv>

          {alert.msg !== '' ?
            <>
              <CheckCircleOutlineOutlinedIcon color={"success"} style={{ fontSize: "4rem" }} />
              <p>{alert.msg}</p>
              <div>
                <Button onClick={() => {
                  setShowDam(false)
                  setAlert({ ...alert, msg: '' })
                }} variant="contained">Ok</Button>
              </div>
            </>
            :
            alert.code === 400 ?
              <>
                <h1>Error!</h1>
                <p>{alert.msg}</p>
                <Button onClick={() => {
                  setShowDam(false)
                  setAlert({ ...alert, msg: '' })
                }} variant="contained" color='warning'>Ok</Button>
              </>
              :
              <>
                <h1>Are you sure?</h1>
                <p>Do you want to process the Leads?</p>
                <div>
                  <Button sx={{ marginRight: '1rem' }} onClick={() => {
                    setShowDam(false)
                    setAlert({ ...alert, msg: '' })
                  }} variant="contained" color='error'>Cancel</Button>

                  <Button onClick={() => {
                    confirmRelease()
                  }} variant="contained">Yes</Button>
                </div>
              </>}


        </ModalAlertDiv>
      </ModalAlert>
    </TableBar >
  );
}

export default Dam;